export default "__VITE_ASSET__RM7TW7OF__"